// views/proveedores/productos/EditarProductoProveedor.js

import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import {
    obtenerProductoProveedor,
    limpiarProductoProveedor,
    editarProductoProveedor,
} from '../../../actions/proveedores';

const EditarProductoProveedor = ({ show, onClose, producto, idProveedor }) => {
    const dispatch = useDispatch();

    const { detalles } = useSelector(state => state.proveedores.productos);

    const [statusProcesar, setStatusProcesar] = useState(false);

    // Sólo para mostrar el nombre del producto (readonly)
    const [productName, setProductName] = useState('');

    const [formData, setFormData] = useState({
        _id: null,
        id_proveedor: null,
        id_producto: null,
        codigo_tienda: '',
        codigo_proveedor: '',
        precio_publico: '',
        precio_minimo: '',
        precio_liquidacion: '',
    });

    const {
        codigo_tienda,
        codigo_proveedor,
        precio_publico,
        precio_minimo,
        precio_liquidacion,
    } = formData;

    const handleChangeInput = ({ target }) => {
        setFormData({
            ...formData,
            [target.name]: target.value,
        });
    };

    const handleCerrar = () => {
        if (statusProcesar) return;

        setFormData({
            _id: null,
            id_proveedor: null,
            id_producto: null,
            codigo_tienda: '',
            codigo_proveedor: '',
            precio_publico: '',
            precio_minimo: '',
            precio_liquidacion: '',
        });
        setProductName('');

        dispatch(limpiarProductoProveedor());
        onClose();
    };

    const handleGuardar = async () => {
        if (!formData._id) return;

        if (!codigo_tienda || !codigo_proveedor) {
            // Aquí puedes meter un setAlert si quieres validar más fuerte
            return;
        }

        await setStatusProcesar(true);

        await dispatch(
            editarProductoProveedor({
                ...formData,
                id_proveedor: formData.id_proveedor || idProveedor,
            })
        );

        await setStatusProcesar(false);
        handleCerrar();
    };

    // Cuando se abre el modal, pide el detalle al backend
    useEffect(() => {
        if (show && producto && producto._id) {
            dispatch(obtenerProductoProveedor(producto._id));
        }
    }, [show, producto, dispatch]);

    // Cuando llegan los detalles desde Redux, rellena el formulario
    useEffect(() => {
        if (detalles && producto && detalles._id === producto._id) {
            setFormData({
                _id: detalles._id,
                id_proveedor: detalles.id_proveedor,
                id_producto: detalles.id_producto,
                codigo_tienda: detalles.codigo_tienda || '',
                codigo_proveedor: detalles.codigo_proveedor || '',
                precio_publico: detalles.precio_publico || '',
                precio_minimo: detalles.precio_minimo || '',
                precio_liquidacion: detalles.precio_liquidacion || '',
            });

            setProductName(detalles.nombre || '');
        }
    }, [detalles, producto]);

    return (
        <Modal show={show} size="lg" backdrop="static" centered onHide={handleCerrar}>
            <Modal.Header closeButton>
                <Modal.Title>Editar producto del proveedor</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="row">
                    {/* Producto SOLO lectura */}
                    <div className="col-md-12 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating w-100">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="producto_nombre"
                                    name="producto_nombre"
                                    placeholder="Producto"
                                    value={productName}
                                    readOnly
                                />
                                <label htmlFor="producto_nombre">Producto</label>
                            </div>
                        </div>
                    </div>

                    {/* Código tienda (solo lectura) */}
                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="codigo_tienda"
                                    name="codigo_tienda"
                                    placeholder="Código tienda"
                                    value={codigo_tienda}
                                    readOnly   // 👈 no editable
                                />
                                <label htmlFor="codigo_tienda">Código tienda</label>
                            </div>
                        </div>
                    </div>

                    {/* Código proveedor (editable) */}
                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input
                                    type="text"
                                    className="form-control"
                                    id="codigo_proveedor"
                                    name="codigo_proveedor"
                                    placeholder="Código proveedor"
                                    value={codigo_proveedor}
                                    onChange={handleChangeInput}
                                />
                                <label htmlFor="codigo_proveedor">Código proveedor</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {/* Precio público */}
                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input
                                    type="number"
                                    className="form-control"
                                    id="precio_publico"
                                    name="precio_publico"
                                    placeholder="Precio público"
                                    value={precio_publico}
                                    onChange={handleChangeInput}
                                />
                                <label htmlFor="precio_publico">Precio público</label>
                            </div>
                        </div>
                    </div>

                    {/* Precio mínimo */}
                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input
                                    type="number"
                                    className="form-control"
                                    id="precio_minimo"
                                    name="precio_minimo"
                                    placeholder="Precio mínimo"
                                    value={precio_minimo}
                                    onChange={handleChangeInput}
                                />
                                <label htmlFor="precio_minimo">Precio mínimo</label>
                            </div>
                        </div>
                    </div>

                    {/* Liquidación */}
                    <div className="col-md-4 form-group mb-3">
                        <div className="input-group">
                            <div className="form-floating">
                                <input
                                    type="number"
                                    className="form-control"
                                    id="precio_liquidacion"
                                    name="precio_liquidacion"
                                    placeholder="Precio liquidación"
                                    value={precio_liquidacion}
                                    onChange={handleChangeInput}
                                />
                                <label htmlFor="precio_liquidacion">Liquidación</label>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={handleCerrar}
                    disabled={statusProcesar}
                >
                    <i className="fas fa-times fa-sm"></i> Cancelar
                </button>

                {statusProcesar ? (
                    <button type="button" className="btn btn-success" disabled>
                        <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                        ></span>{' '}
                        Guardando
                    </button>
                ) : (
                    <button
                        type="button"
                        className="btn btn-success"
                        onClick={handleGuardar}
                    >
                        <i className="fas fa-check fa-sm"></i> Guardar
                    </button>
                )}
            </Modal.Footer>
        </Modal>
    );
};

export default EditarProductoProveedor;
